import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import type { ServiceLink } from '../../data/services';
type ServiceItemListProps = {
  items: ServiceLink[];
  label: string;
};
export function ServiceItemList({
  items,
  label
}: ServiceItemListProps) {
  return <ul aria-label={label} className="mt-3 space-y-1" data-id="element-284" data-mp="devb5vz7gzjb">
      {items.map(item => {
      const internal = item.href?.startsWith('/') ?? false;
      return <li key={item.label} data-id="element-285" data-mp="3uu20r2dr0xkk">
            {item.href ? <a href={item.href} {...internal ? {} : {
          target: '_blank',
          rel: 'noopener noreferrer'
        }} className="focus-ring group flex min-h-[44px] items-start gap-2.5 py-2 text-[15px] leading-[1.5] text-charcoal transition-colors duration-150 hover:text-olive" data-id="element-286" data-mp="3hphqh34cwfx">
                <span className="mt-[9px] h-1 w-1 shrink-0 rounded-full bg-moss/65" aria-hidden="true" data-id="element-287" data-mp="3bx96b2suhqon" />
                <span className="underline decoration-charcoal/20 underline-offset-4 transition-colors group-hover:decoration-olive" data-id="element-288" data-mp="3gusnaagxghka">{item.label}</span>
                {internal ? <ArrowRightIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-moss" strokeWidth={1.5} aria-hidden="true" data-id="element-289" data-mp="19bchkpw9cz4v" /> : <>
                    <ArrowUpRightIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-moss" strokeWidth={1.5} aria-hidden="true" data-id="element-290" data-mp="1j9sa8xaxoggh" />
                    <span className="sr-only" data-id="element-291" data-mp="vl92qjzpk7pg">(opens in a new tab)</span>
                  </>}
              </a> : <span className="flex min-h-[44px] items-start gap-2.5 py-2 text-[15px] leading-[1.5] text-charcoal/80" data-id="element-292" data-mp="14crfsm1cy7eb">
                <span className="mt-[9px] h-1 w-1 shrink-0 rounded-full bg-moss/65" aria-hidden="true" data-id="element-293" data-mp="zlj7xufoeu39" />
                <span data-id="element-294" data-mp="bvypdcnfpyui">{item.label}</span>
              </span>}
            {item.description ? <p className="pb-2 pl-3.5 text-[13.5px] leading-relaxed text-charcoal/65" data-id="element-295" data-mp="7veru7yy8t7u">{item.description}</p> : null}
          </li>;
    })}
    </ul>;
}